import {
  deserialize,
  serializable,
  custom,
  object,
  serialize,
} from 'serializr';
import { Base } from './base.model';
import { PageObject } from './page-object.model';
import { User } from './user.model';

import dayjs from 'dayjs';
import { ApplicationVersion } from './application-version.model';
import { RequirementType } from './requirement-type.model';

export class Requirement extends Base implements PageObject {
  @serializable
  public applicationVersionId: number;
  @serializable
  public requirementName: string;
  @serializable(
    custom(
      (v) => {
        if (v) return JSON.stringify(v);
      },
      (v) => {
        if (v && typeof v == 'string') return JSON.parse(v);
        else if (v) return v;
      },
    ),
  )
  public customFields: object;
  @serializable
  public createdById: number;
  @serializable
  public updatedById: number;
  @serializable
  public requirementDescription: string;
  @serializable
  public requirementTypeId: number;
  @serializable
  public type: string;
  @serializable(
    custom(
      (v) => v,
      (v) => dayjs(v).toDate(),
    ),
  )
  public startTime: Date;
  @serializable(
    custom(
      (v) => v,
      (v) => dayjs(v).toDate(),
    ),
  )
  public endTime: Date;
  @serializable
  public plannedManualCount: number;
  @serializable
  public plannedAutomationCount: number;
  @serializable(object(RequirementType))
  public requirementType: RequirementType;

  public createdBy: User;
  public updatedBy: User;
  public isSelected: boolean;
  @serializable(object(ApplicationVersion))
  public version: ApplicationVersion;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Requirement, input));
  }
  serialize(): JSON {
    return serialize(this);
  }
  // @ts-ignore
  get name(): string {
    return this.requirementName;
  }
}
